import { useAuth } from "../lib/auth";

/**
 * Returns whether the current company account is locked (pending / approved-but-unpaid /
 * past_due / canceled) and the raw status string.
 *
 * Use `isLocked` to disable action buttons and show a tooltip.
 * Grandfathered / active companies return isLocked = false.
 * Non-company users also return isLocked = false so the hook is safe to call anywhere.
 */
export default function useCompanyGated() {
  const { user } = useAuth();
  const status = user?.company_billing?.company_status;

  const isLocked = Boolean(
    status && status !== "active"
  );

  return { isLocked, status };
}
